import {mapGetters, mapActions, mapState} from 'vuex';

import eventsModule from '@events/module/store/type'

export default {
    computed: {
        ...mapGetters({
            membershipRequests: eventsModule.getters.membershipRequests
        }),
        ...mapState({
            profile: 'profile'
        })
    },
    methods: {
        ...mapActions({
            requirementsAlertShow: 'requirementsAlertShow',
        }),
        createEvent(type) {

            if(this.showJoinModalIfNeed()){
                return false;
            }
            if (!this.userIsPro && this.myEvents.length >= window.FREE_EVENTS_LIMIT) {
                this.requirementsAlertShow('events')
            } else {
                let entityType = type === 'bang' ? 'event' : 'event'
                console.log('createEvent', { entityType })
                if (this.isDesktop) {
                    this.openEventModal(null, entityType, 'create')
                } else {
                    this.$router.push({ name: 'create-' + entityType })
                }
            }
        },
        editSpot(spotId, type){
            console.log('editSpot', { spotId })
            if (this.isDesktop) {
                this.openEventModal(spotId, 'spot', 'edit')
            } else {
                this.$router.push({
                    name: 'edit-spot',
                    params: { spotId }
                })
            }
        },
        editEvent(eventId, type){
            let entityType = type === 'bang' ? 'bang' : (type == 'club' ? 'club' : 'event')
            console.log('editEvent', { entityType, eventId })
            if (this.isDesktop) {
                this.openEventModal(eventId, entityType, 'edit')
            } else {
                this.$router.push({
                    name: 'edit-' + entityType,
                    params: { eventId }
                })
            }
        },
        openEvent(eventId, type) {
            let entityType = type === 'spot' ? 'spot' : (type === 'bang' ? 'bang' : (type === 'club' ? 'club' : 'event'));
            console.log('openEvent', { entityType, eventId })
            if (this.isDesktop) {
                if (this.$route.name !== 'events') {
                    this.$router.push({name:'events'})
                }
                this.openEventModal(eventId, entityType)
            } else {
                this.$router.push({
                    name: entityType,
                    params: { eventId },
                    query: { nav: 'chat' }
                }).catch(err => {
                    // Check if the error is due to redundant navigation
                    if (err.name === 'NavigationDuplicated') {
                        location.reload();
                    }
                });
            }
            this.$store.commit('updateMyEvent', {
                id: eventId,
                is_new: false
            })
        },
        async openEventModal(eventId, type, mode) {
            await this.$store.commit(eventsModule.mutations.setTransitionEnabled, false);
            await this.$store.dispatch(eventsModule.actions.setBang, {visible: false});
            if(type !== 'spot'){
                await this.$store.dispatch(eventsModule.actions.setEvent, {visible: false});
            }
            await this.$store.commit(eventsModule.mutations.setTransitionEnabled, true);
            let response = false;
            if (mode !== 'create') {
                console.log('[openEventModal] LoadInfo')

                if (!!app.EventInfoCancelSource) {
                    app.EventInfoCancelSource.cancel()
                    app.EventInfoCancelSource = null
                }
                if(type === 'spot'){
                    response = await this.$store.dispatch(eventsModule.actions.spot.loadInfo, {id: eventId, edit : mode === 'edit' ? 1: 0})
                }else{
                    response = await this.$store.dispatch(eventsModule.actions.events.loadInfo, {eventId: eventId, edit : mode === 'edit'  ? 1 : 0})
                }
            }
            if(mode === 'create' || response){
                let self = this;
                let payload = {
                    visible: true,
                    eventId: eventId,
                    mode: mode || 'view'
                }
                console.log('[openEventModal]', payload)

                self.$store.dispatch(
                    type === 'spot' ? eventsModule.actions.setSpot :  (type === 'bang' ?
                        eventsModule.actions.setBang
                        :
                        eventsModule.actions.setEvent),
                    payload
                )

            }

        },
        closeEvent() {
            this.$store.dispatch(eventsModule.actions.setEvent, { visible: false })
        },
        closeSpot() {
            this.$store.dispatch(eventsModule.actions.setSpot, { visible: false })
        },
        closeBang() {
            this.$store.dispatch(eventsModule.actions.setBang, { visible: false })
        },
        async handleEventInvitation(type, data, callback)
        {
            return await axios.post('/api/handle-invitation/'+type, data).then(response => {
                //all is good, no need to do anything
                callback();
            }).catch((e) => {

            });
        },
        deleteEventInvitation(data)
        {
            return this.handleEventInvitation('delete', data);
        },
        acceptEventInvitation(data, callback)
        {
            return this.handleEventInvitation('accept', data, callback);
        },
        declineEventInvitation(data)
        {
            return this.handleEventInvitation('decline', data);
        },
        resetEventsAround() {
            console.log('[Events] Reset')

            this.$store.commit(eventsModule.mutations.events.set, []);
            this.$store.commit(eventsModule.mutations.resetPagination)

            app.lastEventsAroundRefresh = moment();

            //otherwise it would scroll to the bottom when you change filter
            $('#js-events-content').animate({scrollTop: 0}, 0);
            if (this.$refs.infiniteLoadingEvents) {
                this.$refs.infiniteLoadingEvents.stateChanger.reset()
            } else {
                console.log('No infiniteLoadingEvents ref found')
            }
        },
        async loadEvents(infiniteScroll) {
            let datesCount = await this.$store.dispatch(eventsModule.actions.events.load)
            if (datesCount) {
                infiniteScroll.loaded()
            }
            if (datesCount < window.LOAD_EVENTS_DATES_PER_PAGE) {
                infiniteScroll.complete()
            }
        },
    }
}
